import React, { createContext, useContext } from 'react';
import { useViewport } from '../../hooks/useViewport';

const ViewportContext = createContext(null);

/**
 * 在应用根部包裹，子组件可通过 useViewportContext() 获取视口信息
 * 可选：不包裹时子组件可直接用 useViewport()
 */
export function ResponsiveProvider({ children }) {
  const viewport = useViewport();
  return (
    <ViewportContext.Provider value={viewport}>
      {children}
    </ViewportContext.Provider>
  );
}

export function useViewportContext() {
  const ctx = useContext(ViewportContext);
  if (ctx) return ctx;
  return null;
}
